import axios from "../config/axios";

export interface ImageAnalysis {
  _id?: string;
  recording_id: number;
  transaction_id?: string;
  image_name?: string;
  title?: string;
  filename?: string;
  date?: string;
  created_at?: string;
  status: string;
  document_type: string;
  processing_type?: string;
  source?: string;
  completed?: boolean;
  analysis?: {
    title: string;
    overall_impression: string;
    findings: {
      description: string;
      location: string;
      coordinates: {
        x: string;
        y: string;
        width: string;
        height: string;
      };
      severity: string;
      diagnostic_confidence: string;
    }[];
    comparison: string;
    conclusion: string;
  };
  image_url?: string;
  errors: null | string;
  user_id: number;
  metadata?: {
    source: string;
    analysis_type: string;
    image_analysis_version: string;
  };
  analysis_date?: string;
  description?: string;
  image_type?: string;
  analyzed_by?: string;
  findings?: {
    description: string;
    location: string;
    coordinates: {
      x: number;
      y: number;
      width: number;
      height: number;
    };
    severity: string;
    confidence?: string;
    diagnostic_confidence?: string;
  }[];
  impressions?: string;
}

export interface PaginationData {
  total: number;
  page: number;
  per_page: number;
  pages: number;
}

export interface ImageAnalysesResponse {
  analyses: ImageAnalysis[];
  pagination: PaginationData;
}

export const imageAnalysisService = {
  async getImageAnalyses(page: number = 1, perPage: number = 20): Promise<ImageAnalysesResponse> {
    const response = await axios.get(`/api/scribing/speech/image-analyses?page=${page}&per_page=${perPage}`);
    return response.data;
  },
  
  async getImageAnalysisByRecordingId(recordingId: string | number): Promise<ImageAnalysis> {
    const response = await axios.get(`/api/scribing/speech/image-analyses/by-recording/${recordingId}`);
    return response.data;
  },
}; 